<template>
  <div class="font-opensans cat-page">

    <div class="cat-header">
      <div class="cat-header-title">
        <b-icon icon="box-seam" font-scale="1.1"></b-icon>
        <span>Gestión de Suministros</span>
      </div>
      <b-button class="cat-header-back" @click="goBack()">
        <b-icon icon="arrow-left"></b-icon> Regresar
      </b-button>
    </div>

    <div class="cat-form-card">
      <b-form @submit.prevent="guardarSuministro">
        <!-- Clave del suministro -->
        <b-row>
          <b-col cols="12" md="6">
            <b-form-group label="Clave:" label-for="clave" class="pt-2 pb-3">
              <b-form-input
                id="clave"
                v-model="suministro.clave"
                maxlength="20"
                required
                placeholder="Ingrese la clave del suministro"
                class="mt-1 shadow-sm"
                :style="{'backgroundColor':suministro.color}"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-button @click="abrirModales('modal-colores')" class="cat-back-btn mt-2"><b-icon icon="palette"></b-icon> Elegir Color</b-button>
            <!-- <b-row>
              <b-col cols="12" md="4">
                
              </b-col>
              <b-col cols="12" md="4" class="text-start">
                <div class="text-center mt-4" style="width: 80px; height: 30px; border-radius: 5px" :style="{'backgroundColor':suministro.color}">{{suministro.color}}</div>
              </b-col>
            </b-row> -->
          </b-col>
          
          
        </b-row>
        <b-row>
          <!-- Descripción del suministro -->
          <b-col cols="12" md="6">
            <b-form-group label="Descripción:" label-for="descripcion" class="pt-2 pb-3">
              <b-form-input
                id="descripcion"
                v-model="suministro.descripcion"
                maxlength="150"
                required
                placeholder="Descripción del suministro"
                class="mt-1 shadow-sm"
              />
            </b-form-group>
          </b-col>
         
         
        </b-row>
  
        <!-- Estatus del suministro -->
        <b-row>
          <!-- Fecha de creación -->
          <b-col cols="12" md="6">
            <label for="">{{ suministro.fecha_hora_creacion }}</label>
            <!-- <b-form-group label="Fecha de Creación:" label-for="fecha_creacion"  class="pt-2 pb-3">
              <b-form-datepicker
                id="fecha_creacion"
                v-model="suministro.fecha_hora_creacion"
                :disabled="true"
                :state="true"
                class="mt-1 shadow-sm"
              /> 
            </b-form-group> -->
          </b-col>
        </b-row>
  
        <!-- Fecha de modificación -->
        <b-row>
          <b-col cols="12" md="6">
            <label for="">{{ suministro.fecha_hora_modif }}</label>
            <!-- <b-form-group label="Fecha de Modificación:" label-for="fecha_modif" class="pb-3">
              <b-form-datepicker
                id="fecha_modif"
                v-model="suministro.fecha_hora_modif"
                :disabled="true"
                :state="true"
                class="mt-1 shadow-sm"
              />
            </b-form-group> -->
          </b-col>
        </b-row>
  
        <!-- Botones de acción -->
        <b-row>
          <b-col>
            <b-button class="cat-back-btn me-2" @click="goBack()"><b-icon icon="arrow-left"></b-icon> Regresar</b-button>
            <b-button type="submit" class="cat-save-btn"><b-icon icon="check2"></b-icon> Guardar</b-button>
          </b-col>
        </b-row>
      </b-form>
      <b-modal ref="modal-colores" hide-header-close scrollable button-size="sm"  title="Elige un color para el suministro" @ok="actualiza_color()">
          <div  class="card shadow p-3 fs-12 text-center"> 
              <sketch-picker v-model="selectedColor"></sketch-picker>
              <div>Color seleccionado: {{ selectedColor.hex }}</div>
              <!-- <b-button @click="saveColor">Guardar Color</b-button> -->
          </div>
          <template #modal-footer="{ ok, cancel }">
              <!-- Emulate built in modal footer ok and cancel button actions -->
              <b-button size="sm" variant="success" @click="ok()">
                  Guardar
              </b-button>
              <b-button size="sm" variant="secondary" @click="cancel()">
                  Cancel
              </b-button>
          </template>
        </b-modal>
      <Modals ref="mod"></Modals>
    </div>
  </div>
  </template>
  
  <script>
  import Modals from '@/components/Modals.vue'
  import {mapState,mapActions} from 'vuex'
  import * as utils from "@/shared/util"
  import { Sketch } from 'vue-color'; 
  export default {
    data() {
      return {
        nuevo: true,
        cargando: false,
        texto: "Suministros",
        suministro: {
          clave: '',
          descripcion: '',
          estatus: 'A',
          fecha_hora_creacion: new Date().toISOString().substring(0, 10),
          fecha_hora_modif: new Date().toISOString().substring(0, 10)
        },
        selectedColor: {
          hex: '#000000'
        },
        opcionesEstatus: [
          { value: 'A', text: 'Activo' },
          { value: 'B', text: 'Baja' }
        ],
      };
    },
    components: {
        Modals,
        'sketch-picker': Sketch
        // Operadores,
    },
    computed: {
      ...mapState(['operador','modal','menu']),
      // name() {
      //   return this.data 
      // }
    },
    created() {
      
      let f=Date();
      this.suministro.fecha_hora_creacion= utils.getDateTime(f)
      this.suministro.fecha_hora_modif=utils.getDateTime(f)
     
      if(this.$route.params.suministro_id != undefined){
        this.suministro=this.$route.params
        this.nuevo=false
      }
      console.info("Los params enviados son:"+ JSON.stringify(this.$route.params) )
      // this.form.estatus=1
      console.log("Es nuevo :" + this.nuevo)
    },
    methods: {
      ...mapActions(['actupdateMenu','actupdateModal']),
      showmodal(tittle,message){
          this.modal.tittle = tittle
          this.modal.message = message
          this.modal.type = 0
          this.actupdateModal(this.modal)
          console.log("ahora contiene:  " + JSON.stringify(this.modal))
          this.$refs.mod.showmodal()
      },
      guardarSuministro() {
        // Lógica para guardar el suministro
        console.log('Suministro guardado:', this.suministro);
        this.cargando=true
        // Aquí puedes manejar la lógica para enviar el formulario
        if(this.nuevo){
          this.$store.dispatch("createSuministro",this.suministro).then((res)=>{
            console.log("dispatch createSuministro trajo: "+JSON.stringify(res))
            if(res.estatus==1){
              this.cargando=false
              this.goBack()
            }else{
              this.cargando=false
              this.showmodal(this.texto, res.message)
            }
          }).catch((error)=>{
            this.cargando=false
            this.showmodal(this.texto, error)
          })
        }else{
          this.$store.dispatch("updateSuministro",this.suministro).then((res)=>{
            console.log("dispatch updateSuministro trajo: "+JSON.stringify(res))
            if(res.estatus==1){
              this.cargando=false
              this.goBack()
            }else{
              this.cargando=false
              this.showmodal(this.texto, res.message)
            }
          }).catch((error)=>{
            this.cargando=false
            this.showmodal(this.texto, error)
          })
        }
      },
      abrirModales(id){
          console.log("El id del modal a mosrar :" + id )
          this.$refs[id].show()
      },
      actualiza_color(){
        if(this.selectedColor.hex=='#000000'){
          this.suministro.color=null
        }else{
          this.suministro.color=this.selectedColor.hex
        }
        console.log("El color seleccionado es: " + this.selectedColor.hex)
      },
      goBack(){
        this.$router.go(-1)
      },
    }
  };
  </script>

  <style scoped>
  @import "@/assets/css/app.css";

  .cat-page { min-height: 100vh; background: #f0f4f8; padding-bottom: 2rem; }
  .cat-header {
    display: flex; align-items: center; justify-content: space-between;
    background: linear-gradient(90deg, #0d2b5e 0%, #1a4d8f 60%, #316ea0 100%);
    padding: 0.75rem 1.5rem; color: #fff;
  }
  .cat-header-title { display: flex; align-items: center; gap: 0.5rem; font-size: 1.1rem; font-weight: 600; }
  .cat-header-back {
    background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.4);
    color: #fff; font-size: 0.85rem; border-radius: 6px; padding: 0.3rem 0.9rem;
  }
  .cat-header-back:hover { background: rgba(255,255,255,0.28); }
  .cat-form-card {
    background: #fff; border-radius: 0 0 12px 12px;
    box-shadow: 0 2px 12px rgba(13,43,94,0.08); padding: 1.5rem; margin: 0 1rem 1rem;
  }
  .cat-save-btn {
    background: linear-gradient(90deg, #0d2b5e, #1a4d8f); border: none;
    color: #fff; border-radius: 6px; padding: 0.4rem 1.2rem; font-weight: 600;
  }
  .cat-save-btn:hover { background: linear-gradient(90deg, #1a4d8f, #316ea0); }
  .cat-back-btn {
    background: transparent; border: 1px solid #6c757d;
    color: #6c757d; border-radius: 6px; padding: 0.4rem 1rem; font-weight: 600;
  }
  .cat-back-btn:hover { background: #6c757d; color: #fff; }
  @media (max-width: 576px) {
    .cat-header { padding: 0.6rem 1rem; }
    .cat-header-title { font-size: 1rem; }
    .cat-form-card { padding: 1rem 0.75rem; margin: 0 0.5rem 1rem; }
    .cat-save-btn, .cat-back-btn { width: 100%; margin-bottom: 0.5rem; }
  }
  </style>
